/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import dayjs from "dayjs";

import { CustomerAPIClient } from "../api_clients";
import { IAuthContext } from "../providers/CognitoAuthProvider";

import { hyphenedYMDFromString } from "helpers/date";
import {
  PreparedRoute,
  PreparedRouteApproval,
  PreparedRouteDetail,
} from "models/preparedRoute";

export const getUserByAPIResponse = (user: any) => ({
  company: user.company,
  departmentEn: user.department_en,
  departmentJp: user.department_jp,
  employeeId: user.employee_id,
  id: user.id,
  nameEn: user.name_en,
  nameJp: user.name_jp,
});

const getPreparedRouteDetailByAPIResponse = (preparedRouteDetail: any) =>
  ({
    arrivalId: preparedRouteDetail.arrival_id,
    arrivalName: preparedRouteDetail.arrival_name
      ? preparedRouteDetail.arrival_name
      : "自宅",
    departureId: preparedRouteDetail.departure_id,
    departureName: preparedRouteDetail.departure_name
      ? preparedRouteDetail.departure_name
      : "自宅",
    distanceKm: preparedRouteDetail.distance_km,
    fare: preparedRouteDetail.fare ? preparedRouteDetail.fare : 0,
    id: preparedRouteDetail.id,
    lineId: preparedRouteDetail.line_id,
    lineName: preparedRouteDetail.line_name,
    orderNo: preparedRouteDetail.order_no,
    time: preparedRouteDetail.time,
    transportationType: preparedRouteDetail.transportation_type,
    transportationTypeName: preparedRouteDetail.transportation_type_name,
    useCommuterPass: preparedRouteDetail.use_commuter_pass,
  } as PreparedRouteDetail);

export const getPreparedRouteByAPIResponse = (preparedRoute: any) =>
  ({
    applicantComment: preparedRoute.applicant_comment,
    approvalStatus: preparedRoute.approval_status,
    approvalStatusName: preparedRoute.approval_status_name,
    approvedAt: preparedRoute.approved_at
      ? new Date(preparedRoute.approved_at)
      : undefined,
    approverComment: preparedRoute.approver_comment,
    arrivalId: preparedRoute.arrival_id,
    arrivalName: preparedRoute.arrival_name
      ? preparedRoute.arrival_name
      : "自宅",
    arrivalCode: preparedRoute.arrival_code,
    arrivalAddress: preparedRoute.arrival_address,
    arrivalAddressInvalidatedAt: preparedRoute.arrival_address_invalidated_at
      ? new Date(preparedRoute.arrival_address_invalidated_at)
      : undefined,
    departureId: preparedRoute.departure_id,
    departureName: preparedRoute.departure_name
      ? preparedRoute.departure_name
      : "自宅",
    departureCode: preparedRoute.departure_code,
    departureAddress: preparedRoute.departure_address,
    departureEndDate: new Date(preparedRoute.departure_end_date),
    endDate: new Date(preparedRoute.end_date),
    id: preparedRoute.id,
    startDate: new Date(preparedRoute.start_date),
    totalDistanceKm: preparedRoute.total_distance_km,
    totalFare: preparedRoute.total_fare,
    totalTime: preparedRoute.total_time,
    type: preparedRoute.type,
    typeName: preparedRoute.type_name,
    preparedRouteDetails: preparedRoute.prepared_route_details.reduce(
      (acc: PreparedRouteDetail[], preparedRouteDetail: any) => [
        ...acc,
        getPreparedRouteDetailByAPIResponse(preparedRouteDetail),
      ],
      []
    ),
    priority: !!preparedRoute.priority,
    user: preparedRoute.user
      ? getUserByAPIResponse(preparedRoute.user)
      : undefined,
  } as PreparedRoute);

export const getPreparedRoute = async (
  auth: IAuthContext,
  at?: string
): Promise<PreparedRoute[]> => {
  // eslint-disable-next-line no-param-reassign
  at = at ? hyphenedYMDFromString(at) : "";
  const routes = await CustomerAPIClient.get(
    auth,
    `/api/prepared_routes/?at=${at}`
  );

  return routes.reduce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc: PreparedRoute[], routes_: any) => [
      ...acc,
      getPreparedRouteByAPIResponse(routes_),
    ],
    []
  );
};

export const updatePreparedRouteExpirationDate = async (
  auth: IAuthContext,
  id: number,
  startDate: Date,
  endDate: Date
): Promise<any> =>
  CustomerAPIClient.update(auth, `/api/prepared_routes/${id}`, {
    start_date: dayjs(startDate).format("YYYY-MM-DD"),
    end_date: dayjs(endDate).format("YYYY-MM-DD"),
  });

export const getPreparedRouteApprovalByAPIResponse = (
  preparedRouteApproval: any
) =>
  ({
    id: preparedRouteApproval.id,
    preparedRouteId: preparedRouteApproval.prepared_route_id,
    applicantComment: preparedRouteApproval.applicant_comment || "",
    approvalStatus: preparedRouteApproval.approval_status,
    approvalStatusName: preparedRouteApproval.approval_status_name,
    approverComment: preparedRouteApproval.approver_comment,
  } as PreparedRouteApproval);
/* eslint-enable */
